/** Link donazione progetto Zionyx (Buy Me a Coffee). */
export const BUY_ME_A_COFFEE_URL = 'https://buymeacoffee.com/zionyx'
